module.exports = __webpack_public_path__ + "img/hero-earth-02.005770eb.png";